import { render, staticRenderFns } from "./InstructionsPage.vue?vue&type=template&id=3c112699&"
import script from "./InstructionsPage.vue?vue&type=script&lang=js&"
export * from "./InstructionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports